import { SearchBase } from "../../../shared/models/search-base";

export class SearchRequestVM extends SearchBase<RequestListDto> {
  requestNumber?: string;
  requestStatusId?: string = null;
  requestTypeId?: string = null;
  dateFrom?: Date;
  dateTo?: Date;
  submitter?: string = null;
}
export class RequestListDto {
  id?: string;
  requestNumber?: string;
  processId?: number;
  requestStatusId?: number;
  requestDate?: Date;
  submitterUserName?: string;
  submitterDisplayNameAr?: string;
  submitterDisplayNameEn?: string;
  requestStatusNameEn?: string;
  requestStatusNameAr?: string;
  requestDateDisplay?: string;
  requestDetailsURL?: string;
  requestTypeNameEn?: string;
  requestTypeNameAr?: string;
  processActivityNameAr?: string;
  processActivityNameEn?: string;
  displayStatus?: string;
}


